import Vue from 'vue'
import Vuex from 'vuex'
import { getTagsByLanguage } from '../language.js'
import { flatArrMenu, initTreeMenu } from './helper.js'
Vue.use(Vuex)
//图片弹框类 状态
const store = new Vuex.Store({
    state: {
        languageData: JSON.parse(sessionStorage.getItem('languageData')) || getTagsByLanguage('zhCn'),
        tagData: [],
        userInfo: sessionStorage.getItem("userInfo") != 'undefined' && JSON.parse(sessionStorage.getItem('userInfo')) || {userId:''},
        CreatorInformation:[],
        flow: {
            type: '',//window,header,floor,footer
            childType: '',//topNav,mainNav,subNav,banner,introduce,library,industry,smartApp,footNav
            floorAvtive: 0,
            tabAvtive: 0,
            rightBtn: false
        },
        //区别楼层类型
        flowType: '',
        //详情页tab导航数据
        detailNav: [],
        blockId: '',
        preItem: '',
        topTabFlag: '',
        //右键
        // rightMenu: JSON.parse(sessionStorage.getItem('rightMenu'))||[],
        rightMenu: [],
        //详情右键
        // rightMenuDetail: JSON.parse(sessionStorage.getItem('rightMenuDetail'))||[],
        rightMenuDetail: [],
        orderList: JSON.parse(sessionStorage.getItem('orderList')),
        //楼层详情页flowId
        flowId: sessionStorage.getItem('flowId') || '',
        //楼层详情页nodeId
        nodeId: sessionStorage.getItem('nodeId') || '',
        //平台创建人id
        creatUserId: '',
        assistUserId: '',
        isManage: sessionStorage.getItem('isManage') || 2,
        flowOrBlockType: 'block',
        isLogin: false,
        width: 0,
        rightType: JSON.parse(sessionStorage.getItem('rightType')) || 531,
        baseURL: window.location.href.indexOf('.com') == -1 ? (window.location.hostname == '10.0.6.19' ? 'https://520emv.com' : window.location.origin) : window.location.origin,
        //右键搜索框内容
        searchContent:'',
        setContentIds:{},
        setInitData:{},
        memberLevel:'',
        winWidth:window.innerWidth,
        winHeight:window.innerHeight,
        Barrage:{},
        showOther:false,
        isOrNotXgwz:false,
        pageFontSize:'',
        Receiver:[],
        Scale:0,
        iconAdd:false,
        NewYearTheme:'',
        wxud:localStorage.getItem('wxud') || '',
        noLoginSid:localStorage.getItem('noLoginSid') || ''
    },
    mutations: {
        setwxud(state,item){
            state.wxud = item
            localStorage.setItem('wxud', item);
        },
        setnoLoginSid(state,item){
            state.noLoginSid = item
            localStorage.setItem('noLoginSid', item);
        },
        setNewYearTheme(state,item){
            state.NewYearTheme = item
        },
        setScale(state,item){
            state.Scale = item
        },
        setReceiver(state,item){
            state.Receiver = item
        },
        pageFontSize(state,item){
            state.pageFontSize = item
        },
        isOrNotXgwz(state,item){
            state.isOrNotXgwz = item
        },
        showOther (state, item) {
            state.showOther = item
        },
        sendBarrage (state, item) {
            state.Barrage = item
        },
        setWinWidth (state, item) {
            state.winWidth = item
        },
        setWinHeight (state, item) {
            state.winHeight = item
        },
        setMemberLevel (state, item) {
            state.memberLevel = item
        },
        setInitData (state, item) {
            state.setInitData = item
        },
        setContentIds (state, item) {
            state.setContentIds = item
        },
        searchContent (state, item) {
            state.searchContent = item
        },
        setflowOrBlockType (state, item) {
            state.flowOrBlockType = item
        },
        setShowBlock (state, f) {
            state.tagData = f;
        },
        setUserInfo (state, u) {
            sessionStorage.setItem('userInfo', JSON.stringify(u) || '');
            state.userInfo = u;
        },
        setCreatorInformation (state, u) {
            state.CreatorInformation = u;
        },
        setFlowType (state, f) {
            //state.flow = Object.assign({}, state.flow, { ...f });
            state.flowType = f;
        },
        setTopTabFlag (state, flag) {
            state.topTabFlag = flag;
        },
        setLanguageData (state, lan) {
            var data = getTagsByLanguage(lan);
            sessionStorage.setItem('languageData', JSON.stringify(data));
            state.languageData = Object.assign({}, state.data, { ...data });
        },
        //设置详情页tab导航数据
        setPreItem (state, item) {
            state.preItem = item;
        },
        //设置详情页tab导航数据
        setDetailNav (state, data) {
            state.blockId = data.blockId;
            var nodeNav = [];
            for (const key in data.list) {
                const item = data.list[key];
                if (key < 1) {
                    nodeNav.push(item);
                } else {
                    nodeNav.push({ id: data.blockId, sceneId: item.sceneId, contentId: item.contentId, sceneGroupId: item.sceneGroupId, name: item.others[0] ? item.others[0].standardData : '' });
                }
            }
            state.detailNav = nodeNav;
        },
        //首页右键数据
        setRightMenu (state, data) {
            const fArr = flatArrMenu(data.menu);
            var tArr = [...initTreeMenu(fArr, 'childmenu', 'parentmenu', 'children'), ...data.append];
            // sessionStorage.setItem('rightMenu', JSON.stringify(tArr));
            state.rightMenu = tArr;
        },
        //详情页面右键数据
        setRightMenuDetail (state, data) {
            const fArr = flatArrMenu(data.menu);
            var tArr = [...initTreeMenu(fArr, 'childmenu', 'parentmenu', 'children'), ...data.append];
            // sessionStorage.setItem('rightMenuDetail', JSON.stringify(tArr));
            state.rightMenuDetail = tArr;
        },
        //订单页面数据
        setOrderPageList (state, data) {
            sessionStorage.setItem('orderList', JSON.stringify(data));
            state.orderList = data;
        },
        //设置详情页flowId
        setFlowId (state, data) {
            sessionStorage.setItem('flowId', data);
            state.flowId = data;
        },
        //设置详情页nodeId
        setNodeId (state, data) {
            sessionStorage.setItem('nodeId', data);
            state.nodeId = data;
        },
        //设置平台创建人id 
        setCreateUserId (state, data) {
            state.creatUserId = data;
        },
        //设置平台会议助理id 
        setAssistUserId (state, data) {
            state.assistUserId = data;
        },
        //设置场景平台状态 
        setManageState (state, data) {
            sessionStorage.setItem('isManage', data);
            state.isManage = data;
        },
        //设置登录状态 
        setLoginState (state, data) {
            state.isLogin = data;
        },
        //屏幕宽度
        watchWidth (state, data) {
            state.width = data;
        },
        //保存右键类型
        rightClickType (state, data) {
            sessionStorage.setItem('rightType', JSON.stringify(data));
            state.rightType = data;
        },
        //左上角图标点击增加参数
        iconAddPam (state, data) {
            state.iconAdd = data;
        }
    }
})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js